/**
 * Custom Cart Page - Simple quantity updates with page reload
 * Simpler than drawer - just handles basic cart operations on the cart page
 */

(function() {
  'use strict';
  
  // Only run on cart page
  if (!document.querySelector('[data-cart-page]')) return;
  
  console.log('Custom cart page JS loaded');
  
  // Initialize quantity controls
  function initQuantityControls() {
    const quantityHolders = document.querySelectorAll('[data-quantity-holder]');
    
    quantityHolders.forEach(holder => {
      const minusBtn = holder.querySelector('[data-quantity-minus]');
      const plusBtn = holder.querySelector('[data-quantity-plus]');
      const input = holder.querySelector('[data-quantity-field]');
      
      if (!minusBtn || !plusBtn || !input) return;
      
      const itemKey = input.getAttribute('data-id');
      
      // Minus button
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentVal = parseInt(input.value) || 1;
        const newVal = Math.max(0, currentVal - 1);
        updateCartItem(itemKey, newVal);
      });
      
      // Plus button
      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentVal = parseInt(input.value) || 0;
        const newVal = currentVal + 1;
        updateCartItem(itemKey, newVal);
      });
      
      // Input change
      input.addEventListener('change', (e) => {
        const newVal = Math.max(0, parseInt(e.target.value) || 0);
        updateCartItem(itemKey, newVal);
      });
    });
  }
  
  // Update cart item via Shopify API
  function updateCartItem(itemKey, quantity) {
    // Disable all controls
    const allButtons = document.querySelectorAll('[data-quantity-button]');
    const allInputs = document.querySelectorAll('[data-quantity-field]');
    
    allButtons.forEach(btn => btn.disabled = true);
    allInputs.forEach(input => input.disabled = true);
    
    // Make the update request
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      // Reload the page to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      // Re-enable controls on error
      allButtons.forEach(btn => btn.disabled = false);
      allInputs.forEach(input => input.disabled = false);
      alert('Kunde inte uppdatera varukorgen. Försök igen.');
    });
  }
  
  // Locked bundle (startpaket): remove every line of the package at once
  function initRemoveBundle() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-remove-bundle]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        const updates = {};
        cart.items.filter(item => item.properties?._bundleId === btn.dataset.removeBundle).forEach(item => { updates[item.key] = 0; });
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error('Failed to remove bundle');
        window.location.reload();
      } catch (error) {
        btn.disabled = false;
        alert('Kunde inte uppdatera varukorgen. Försök igen.');
      }
    });
  }

  // Clear cart functionality (fast path)
  function initClearCart() {
    document.addEventListener('click', async (e) => {
      const clearBtn = e.target.closest('[data-clear-cart]');
      if (!clearBtn) return;
      e.preventDefault();

      const labelEl = clearBtn.querySelector('span');
      const originalLabel = labelEl ? labelEl.textContent : '';
      clearBtn.disabled = true;
      if (labelEl) {
        labelEl.textContent = 'Rensar...';
      }

      try {
        const response = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Failed to clear cart');
        }

        // Reload once to show empty cart state.
        window.location.reload();
      } catch (error) {
        alert('Kunde inte tömma varukorgen. Försök igen.');
      } finally {
        clearBtn.disabled = false;
        if (labelEl) {
          labelEl.textContent = originalLabel;
        }
      }
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initQuantityControls();
      initClearCart();
      initRemoveBundle();
    });
  } else {
    initQuantityControls();
    initClearCart();
    initRemoveBundle();
  }
  
})();
